import { Component, ElementRef, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import Debug from 'debug';
import { CanSize, CanSizeCtor, mixinSize } from '../../style/CanSize';

const debug = Debug('aumico:aumico-lib-core-fe:AumToggle');

class AumToggleBase {
    constructor(public _elementRef: ElementRef) {}
}
const _AumToggleMixinBase: CanSizeCtor & typeof AumToggleBase = mixinSize(AumToggleBase, 'medium');

/**
 * to overwrite the with you have to change the css of .mat-form-field-infix
 */
@Component({
    selector: 'aum-toggle',
    styleUrls: ['./aum-toggle.scss'],
    templateUrl: './aum-toggle.html',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'aum-toggle',
    },
    inputs: ['size'],
})
export class AumToggle extends _AumToggleMixinBase implements CanSize {
    @Input()
    public disabled: boolean;

    @Input()
    public checked = false;

    @Input()
    get caption(): string {
        return this._caption;
    }
    set caption(value: string) {
        if (value !== this._caption) {
            this._caption = value;
        }
    }
    private _caption: string;

    @Input()
    get aumFormControl(): UntypedFormControl {
        return this._aumFormControl;
    }
    set aumFormControl(value: UntypedFormControl) {
        if (value !== this._aumFormControl) {
            this._aumFormControl = value;
        }
    }
    private _aumFormControl: UntypedFormControl;

    @Output() changed = new EventEmitter<boolean>();

    constructor(el: ElementRef) {
        super(el);
    }

    onToggleChange($event: MatSlideToggleChange) {
        this.changed.emit($event.checked);
    }
}
